const API_KEY = '7E7C7ED5-223C-414F-9BF4-CF5DDDAAF8E6';
export default API_KEY;
